<template>
  <div :class="wysiwygClass">
    <editor
      :api-key="tinyMceApiKey"
      model-events="change"
      :initialValue="content"
      @change="handleInput"
      v-model="wysiwyg"
      :init="{
        height: height,
        menubar: false,
        media_dimensions: false,
        media_poster: false,
        media_alt_source: false,
        images_upload_handler: wysiwyg_image_upload_handler,
        language: 'fr_FR',
        plugins: [
          'advlist autolink lists link image charmap print preview anchor image media',
          'searchreplace visualblocks code fullscreen',
          'insertdatetime media table paste code help wordcount',
        ],
        file_picker_types: 'image',
        toolbar:
          'undo redo | formatselect | bold italic backcolor image media | \
           alignleft aligncenter alignright alignjustify | \
           bullist numlist outdent indent | removeformat | help',
      }"
    />
    <FormKit
      type="hidden"
      name="images"
      v-model="images"
    />
  </div>
</template>

<script setup lang="ts">
import Editor from "@tinymce/tinymce-vue";
import ApiService from "@/_services/api.service"
import { ref } from "vue";

const props = defineProps({
  context: Object,
  content: {
    type: String,
    required: true,
    default: "",
  },
  images: {
    type: Array,
    required: true,
    default: () => [],
  },
  height: {
    type: Number,
    default: 300,
  },
  wysiwygClass: {
    type: String,
    default: "",
  },
});

const tinyMceApiKey = process.env.VUE_APP_TINY_MCE_API_KEY;
const images = ref(props.images);
let wysiwyg = ref(props.content ? props.content:  props?.context?.attrs?.content);

function handleInput(e) {
  props.context.node.input(wysiwyg.value)
}

const wysiwyg_image_upload_handler = (blobInfo, success, failure, progress) =>
  new Promise((resolve, reject) => {
    const file = new FormData();
    file.append("file", blobInfo.blob(), blobInfo.filename());
    file.append("context", "product_description");

    ApiService.post("images", file)
      .then((response) => {
        success(response.data.data.url);
        images.value.push(response.data.data);
      })
      .catch((error) => {
        failure({ message: "Une erreur est survenu", remove: true });
      });
  });
</script>

<style scoped lang="scss"></style>